import { useLayoutEffect } from 'react';

const useElementHeightCssVariable = (elementRef, variableName) => {
  useLayoutEffect(() => {
    const element = elementRef.current;
    const root = document.documentElement;
    if (!element || !root || !variableName) return undefined;

    const previousInlineHeight = root.style.getPropertyValue(variableName);
    let measuredHeight = '';
    const updateHeight = () => {
      const nextHeight = `${Math.ceil(element.getBoundingClientRect().height)}px`;
      if (nextHeight === measuredHeight) return;
      measuredHeight = nextHeight;
      root.style.setProperty(variableName, nextHeight);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateHeight);
    observer?.observe(element);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', updateHeight);
      if (previousInlineHeight) {
        root.style.setProperty(variableName, previousInlineHeight);
      } else {
        root.style.removeProperty(variableName);
      }
    };
  }, [elementRef, variableName]);
};

export default useElementHeightCssVariable;
